<template>
    <div class="flex justify-between text-xl text-gray-800">
        <span class="font-semibold">
            {{ headline }}
        </span>

        <Link
            v-if="cta && href"
            class="inline-flex items-center text-base font-semibold text-deep-teal-700 purple-theme:text-purple-700 hover:text-deep-teal-900 purple-theme:hover:text-purple-900 hover:underline focus:underline focus:outline-hidden focus:text-deep-teal-900 purple-theme:focus:text-purple-900"
            :href
            @click="$emit('closeSearch')"
        >
            {{ cta }}

            <ArrowLongRightIcon class="size-5 ml-1.5" />
        </Link>
    </div>
</template>

<script setup>
import { Link } from '@inertiajs/vue3';
import { ArrowLongRightIcon } from '@heroicons/vue/24/solid';

defineEmits(['closeSearch']);

defineProps({
    headline: {
        type: String,
        required: true,
    },
    cta: {
        type: String,
        default: null,
    },
    href: {
        type: String,
        default: null,
    },
});
</script>
